export default "__VITE_ASSET__CIvYNnGt__"